<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "TERMS_OF_USE.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card class="mat-elevation-z0">
    <mat-card-content>
        <iframe [src]="termsOfUse" class="useterms-viewport"> </iframe>
    </mat-card-content>
</mat-card>
